export const AvatarHeadStyle2 = ({ id, colors }) => {
  return (
    <g id="Estilo2_5_">
      <linearGradient
        id={`${id}-SVGID_140_`}
        gradientUnits="userSpaceOnUse"
        x1="62.3591"
        y1="-297.3179"
        x2="21.508"
        y2="-355.1477"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset=".175" style={{ stopColor: colors[1] }} />
        <stop offset=".506" style={{ stopColor: colors[2] }} />
        <stop offset=".568" style={{ stopColor: colors[3] }} />
        <stop offset=".784" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ display: 'inline', fill: `url(#${id}-SVGID_140_)` }}
        d="M58.7,65.7c2.2,4.2,1.3,9.1-2.1,10.8s-7.8-0.3-10.1-4.5 c-2.2-4.2-1.3-9.1,2.1-10.8C52,59.5,56.5,61.5,58.7,65.7z"
      />

      <linearGradient
        id={`${id}-SVGID_141_`}
        gradientUnits="userSpaceOnUse"
        x1="82.3722"
        y1="-291.0465"
        x2="161.8148"
        y2="-389.2361"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset=".175" style={{ stopColor: colors[1] }} />
        <stop offset=".506" style={{ stopColor: colors[2] }} />
        <stop offset=".568" style={{ stopColor: colors[3] }} />
        <stop offset=".784" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ display: 'inline', fill: `url(#${id}-SVGID_141_)` }}
        d="M92.5,65.7c-2.2,4.2-1.3,9.1,2.1,10.8s7.8-0.3,10.1-4.5s1.3-9.1-2.1-10.8 C99.3,59.5,94.8,61.5,92.5,65.7z"
      />

      <linearGradient
        id={`${id}-Multiply_50_`}
        gradientUnits="userSpaceOnUse"
        x1="91.5617"
        y1="-306.6266"
        x2="108.8276"
        y2="-317.0703"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: '#FFE7D8' }} />
        <stop offset="0.2873" style={{ stopColor: '#FABDC9' }} />
        <stop offset="0.5941" style={{ stopColor: '#F597BB' }} />
        <stop offset="0.8407" style={{ stopColor: '#F280B3' }} />
        <stop offset="0.9944" style={{ stopColor: '#F177B0' }} />
      </linearGradient>

      <path
        id="Multiply_6_"
        style={{
          display: 'inline',
          opacity: '0.6',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: `url(#${id}-Multiply_50_)`,
          enableBackground: 'new'
        }}
        d=" M103.6,67.1c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-1.2-0.2-1.9-0.5-2.3c-0.2-0.2-0.4-0.4-0.7-0.4c-0.3,0-0.6,0.1-1,0.3 c-1,0.6-2,1.8-2.5,3.2c-0.3,0.6-0.5,1.3-0.6,1.8c0.6-0.4,1.2-0.6,1.7-0.5c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.4,0.5,0.7 c0.2,0.5,0,1.3-0.5,2.1c-0.1,0.2-0.3,0.2-0.5,0.1c-0.2-0.1-0.2-0.4-0.1-0.5c0.4-0.6,0.5-1.1,0.4-1.4c0-0.1-0.1-0.3-0.2-0.3 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.1-1.1,0.2-1.6,0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.1-0.5-0.1-0.5-0.4l0,0c0-0.1,0-0.3,0-0.4 c0.1-0.6,0.4-1.5,0.8-2.5c0.6-1.5,1.7-2.9,2.8-3.5c0.5-0.3,0.9-0.4,1.4-0.4c0.5,0,0.9,0.2,1.2,0.7 C103.3,64.8,103.6,65.7,103.6,67.1z"
      />

      <linearGradient
        id={`${id}-Multiply_51_`}
        gradientUnits="userSpaceOnUse"
        x1="46.0227"
        y1="-319.1104"
        x2="57.5401"
        y2="-304.3446"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: '#FFE7D8' }} />
        <stop offset="0.2873" style={{ stopColor: '#FABDC9' }} />
        <stop offset="0.5941" style={{ stopColor: '#F597BB' }} />
        <stop offset="0.8407" style={{ stopColor: '#F280B3' }} />
        <stop offset="0.9944" style={{ stopColor: '#F177B0' }} />
      </linearGradient>

      <path
        id="Multiply_5_"
        style={{
          display: 'inline',
          opacity: '0.6',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: `url(#${id}-Multiply_51_)`,
          enableBackground: 'new'
        }}
        d=" M48,67.1c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0-1.2,0.2-1.9,0.5-2.3c0.2-0.2,0.4-0.4,0.7-0.4c0.3,0,0.6,0.1,1,0.3 c1,0.6,2,1.8,2.5,3.2c0.3,0.6,0.5,1.3,0.6,1.8c-0.6-0.4-1.2-0.6-1.7-0.5c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.4,0.4-0.5,0.7 c-0.2,0.5,0,1.3,0.5,2.1c0.1,0.2,0.3,0.2,0.5,0.1s0.2-0.4,0.1-0.5c-0.4-0.6-0.5-1.1-0.4-1.4c0-0.1,0.1-0.3,0.2-0.3 c0.1-0.1,0.3-0.1,0.4-0.2c0.5-0.1,1.1,0.2,1.6,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.5-0.1,0.5-0.4l0,0c0-0.1,0-0.3,0-0.4 c-0.1-0.6-0.4-1.5-0.8-2.5c-0.6-1.5-1.7-2.9-2.8-3.5c-0.5-0.3-0.9-0.4-1.4-0.4c-0.5,0-0.9,0.2-1.2,0.7C48.3,64.8,48,65.7,48,67.1z "
      />

      <linearGradient
        id={`${id}-SVGID_142_`}
        gradientUnits="userSpaceOnUse"
        x1="76.045"
        y1="391.1669"
        x2="76.045"
        y2="449.9985"
        gradientTransform="matrix(1 0 0 -1 0 480)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset=".175" style={{ stopColor: colors[1] }} />
        <stop offset=".506" style={{ stopColor: colors[2] }} />
        <stop offset=".568" style={{ stopColor: colors[3] }} />
        <stop offset=".784" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        id="SVGID_83_"
        style={{ display: 'inline', fill: `url(#${id}-SVGID_142_)` }}
        d="M95.4,71.8c0.3-1.4,0.6-3,0.9-4.8 c0.3-5.4,1.3-7.9,1.3-11.4c0-12.4-9.1-21-21.6-21s-21.5,8.5-21.5,21c0,3,0,5,0.7,10c0.2,1.7,0.5,3.6,0.9,5.5 c-0.1,2.2-0.4,4.4-0.2,6.6c-0.4,7.4,6.3,13.8,16.3,13.7c2.6,0,5.2,0,7.8,0c11,0.1,17.3-7.4,15.3-15.7c0-0.8,0-1.6,0-2.4 C95.3,72.7,95.4,72.2,95.4,71.8z"
      />
      <g style={{ display: 'inline' }}>
        <defs>
          <path
            id={`${id}-SVGID_143_`}
            d="M95.4,71.8c0.3-1.4,0.6-3,0.9-4.8c0.3-5.4,1.3-7.9,1.3-11.4c0-12.4-9.1-21-21.6-21s-21.5,8.5-21.5,21 		c0,3,0,5,0.7,10c0.2,1.7,0.5,3.6,0.9,5.5c-0.1,2.2-0.4,4.4-0.2,6.6c-0.4,7.4,6.3,13.8,16.3,13.7c2.6,0,5.2,0,7.8,0 		c11,0.1,17.3-7.4,15.3-15.7c0-0.8,0-1.6,0-2.4C95.3,72.7,95.4,72.2,95.4,71.8z"
          />
        </defs>
        <clipPath id={`${id}-SVGID_144_`}>
          <use
            xlinkHref={`#${id}-SVGID_143_`}
            style={{ overflow: 'visible' }}
          />
        </clipPath>

        <linearGradient
          id={`${id}-Multiply_52_`}
          gradientUnits="userSpaceOnUse"
          x1="75.68"
          y1="368.9755"
          x2="75.68"
          y2="418.1023"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>
        <path
          id="Multiply_4_"
          style={{
            opacity: '0.6',
            clipPath: `url(#${id}-SVGID_144_)`,
            fill: `url(#${id}-Multiply_52_)`,
            enableBackground: 'new'
          }}
          d=" 	M80.2,89.1c-2.8,0-5.6,0-8.3,0c-6.8,0.1-12.2-2.4-15.1-6.2c2.2,5,7.8,8.6,15.4,8.5c2.6,0,5.2,0,7.8,0c7.4,0.1,12.6-3.3,14.7-8.1 	C91.8,86.8,86.8,89.2,80.2,89.1z"
        />
      </g>
    </g>
  )
}
